"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaunchbeesCore = void 0;
var DEFAULT_ENDPOINT = "https://api.launchbees.com/sdk/v1/users";
var FlagsChangedEvent = new Event("lb_flags_changed");
var LaunchbeesCore = /** @class */ (function () {
    function LaunchbeesCore() {
    }
    LaunchbeesCore.prototype.init = function (_a) {
        var _b = _a.endpoint, endpoint = _b === void 0 ? DEFAULT_ENDPOINT : _b, environmentKey = _a.environmentKey;
        this.endpoint = endpoint;
        this.environmentKey = environmentKey;
        this.flags = new Map([]);
    };
    LaunchbeesCore.prototype.identify = function (userInfo) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.user = userInfo;
                this.getFlags(this.user);
                return [2 /*return*/];
            });
        });
    };
    LaunchbeesCore.prototype.getFlags = function (traits) {
        return __awaiter(this, void 0, void 0, function () {
            var response, features;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, window.fetch(this.endpoint, {
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-API-Key': this.environmentKey,
                            },
                            body: JSON.stringify(traits)
                        })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        features = (_a.sent()).data;
                        features.forEach(function (feature) {
                            _this.flags.set(feature.featureKey, feature);
                        });
                        document.dispatchEvent(FlagsChangedEvent);
                        return [2 /*return*/, features];
                    case 3:
                        console.log("Failed to fetch feature flags");
                        _a.label = 4;
                    case 4: return [2 /*return*/, []];
                }
            });
        });
    };
    LaunchbeesCore.prototype.hasFeature = function (featureKey) {
        var hasFeature = this.flags.has(featureKey);
        if (hasFeature) {
            return this.flags.get(featureKey).isEnabled;
        }
        return false;
    };
    return LaunchbeesCore;
}());
exports.LaunchbeesCore = LaunchbeesCore;
